import { render, staticRenderFns } from "./XFilterChipList.vue?vue&type=template&id=b39815dc"
import script from "./XFilterChipList.vue?vue&type=script&lang=js"
export * from "./XFilterChipList.vue?vue&type=script&lang=js"
import style0 from "./XFilterChipList.vue?vue&type=style&index=0&id=b39815dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports